import { TabBar } from 'antd-mobile'
import Home from './Home';
import Member from './Member';
import UploadMember from './Member/UploadMember';
import MemberInfo from './Member/MemberInfo';
import AdminEditMember from './Member/AdminEditMember';
import GameCreate from './Game/GameCreate';
import Applicate from './Applicate';
import ApplicateOne from './Applicate/ApplicateOne';
import ApplicateTwo from './Applicate/ApplicateTwo';
import ApplicateList from './Applicate/ApplicateList';
import ApplicateFour from './Applicate/ApplicateFour';
import ApplicateThree from './Applicate/ApplicateThree';
import GameHistory from './Game/GameHistory';
import GameHistoryDetail from './Game/GameHistoryDetail';
import Login from './Login'
import Charts from './Charts';
import UpdatePassword from './Auth/UpdatePassword';
import CustomSeason from './Member/CustomSeason';
import SeasonInsert from './Member/CustomSeason/SeasonInsert';
import FirstTeam from './Applicate/FirstTeam';
import AvatarAudit from './Auth/AvatarAudit';
import AvatarMember from './Auth/AvatarMember';
import LevelAudit from './Auth/LevelAudit';
import CreateTeam from './Team/CreateTeam'
import TeamList from './Team/TeamList';
import TeamMember from './Team/TeamMember';
import ActiveCharts from './Team/ActiveCharts';
import PositionAudit from './Auth/PositionAudit';
import { Route, useNavigate, Routes, Navigate, useLocation } from 'react-router-dom';
import {
  AppOutline,
  TagOutline,
  UnorderedListOutline,
  UserOutline,
} from 'antd-mobile-icons'
import { useEffect, useRef, useState } from 'react';
import CreateDinner from './Dinner/CreateDinner';
import DinnerList from './Dinner/DinnerList';
import DinnerDetail from './Dinner/DinnerDetail';
import UpdateDinner from './Dinner/UpdateDinner';
import GameUpdate from './Game/GameUpdate';
import GameYear from './GameYear';
import GameYearList from './GameYear/GameYearList';
import GameYearCreate from './GameYear/GameYearCreate';
import GameYearUpdate from './GameYear/GameYearUpdate';
import CreateGamePk from './GameYear/CreateGamePk';
import LittleGameInfo from './GameYear/littleGameInfo';
import Confrontation from './Confrontation';
import Album from './Album';
import AlbumUpload from './Album/AlbumUpload';
import HappyEvent from './HappyEvent';
import HappyEventCreate from './HappyEvent/HappyEventCreate';
import { useAuth } from './app/providers/AuthProvider';

function App() {
  const { memberInfo, isAuthenticated, isGuest } = useAuth()

  const navigate = useNavigate()

  const [activeKey, setActiveKey] = useState('home')

  const scrollContainerRef = useRef(null);

  const { pathname } = useLocation();

  const isLoginPage = pathname === '/login';
  const isLoggedIn = isAuthenticated;
  const showTabBar = isLoggedIn && !isLoginPage;
  const shouldBlockProtectedPage = !isLoggedIn && !isLoginPage;

  const getTabKeyByPath = (path) => {
    if (path === '/charts') return 'charts'
    if (path === '/member' || path === '/uploadMember' || path === '/avatarAudit' || path === '/avatarMember' || path === '/levelAudit' || path === '/positionAudit' || /^\/members\/[^/]+\/edit$/.test(path)) return 'member'
    if (path === '/memberInfo' || path.startsWith('/members/') || path === '/changeUser' || path === '/updatePassword' || path === '/customSeason' || path === '/seasonInsert') return 'memberInfo'
    return 'home'
  }

  const handleTabNavigate = (value) => {
    // 未登录时即使触发底部菜单点击，也统一回到登录页。
    if (!memberInfo) {
      navigate(`/login`)
      return
    }
    if (value === 'memberInfo') {
      // 访客没有真实球员档案，点击“我的”时引导回登录页。
      if (isGuest) {
        navigate(`/login`)
        return
      }
      navigate(`/members/${memberInfo.id}`)
    } else {
      navigate(`/${value}`)
    }
    setActiveKey(value)
  }

  useEffect(() => {
    // 全局登录守卫：未登录直接访问任意页面时，统一先进入登录页，避免各页面重复判断遗漏。
    if (!isLoggedIn && !isLoginPage) {
      navigate('/login', { replace: true });
      return;
    }
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    } else {
      window.scrollTo(0, 0);
    }
    // 底部菜单高亮跟随真实路由，避免进入子页面后 activeKey 停留在旧状态。
    setActiveKey(getTabKeyByPath(pathname))
  }, [pathname, navigate, isLoggedIn, isLoginPage]);

  const tabs = [
    {
      key: 'home',
      title: '首页',
      icon: <AppOutline />,
    },
    {
      key: 'charts',
      title: '榜单',
      icon: <TagOutline />,
    },
    {
      key: 'member',
      title: '球员',
      icon: <UnorderedListOutline />,
    },
    {
      key: 'memberInfo',
      title: '我的',
      icon: <UserOutline />,
    },
  ]

  const activeTabIndex = Math.max(tabs.findIndex(item => item.key === activeKey), 0)


  return (
    <div className='body'>
      <div
        ref={scrollContainerRef}
        style={{ height: showTabBar ? 'calc(100vh - 50px)' : '100vh', overflow: 'auto' }}>
        {shouldBlockProtectedPage ? <Routes>
          {/* 未登录直接访问站内任意地址时，只渲染登录页跳转，避免目标页面先闪现。 */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes> : <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/member" element={<Member />} />
          <Route path='/uploadMember' element={<UploadMember />} />
          <Route path='/memberInfo' element={<MemberInfo />} />
          {/* 新详情路由把业务 ID 放入 URL，旧路由暂时保留用于兼容历史入口。 */}
          <Route path='/members/:memberId' element={<MemberInfo />} />
          {/* 管理员维护球员个人档案的独立页面。 */}
          <Route path='/members/:memberId/edit' element={<AdminEditMember />} />
          <Route path='/gameCreate' element={<GameCreate />} />
          <Route path='/applicate' element={<Applicate />} />
          <Route path='/applicateOne' element={<ApplicateOne />} />
          <Route path='/games/:gameId/signup' element={<ApplicateOne />} />
          <Route path='/applicateTwo' element={<ApplicateTwo />} />
          <Route path='/games/:gameId/ready' element={<ApplicateTwo />} />
          <Route path='/applicateList' element={<ApplicateList />} />
          <Route path='/applicateFour' element={<ApplicateFour />} />
          <Route path='/games/:gameId/live' element={<ApplicateFour />} />
          <Route path='/applicateThree' element={<ApplicateThree />} />
          <Route path='/gameHistory' element={<GameHistory />} />
          <Route path='/gameHistoryDetail' element={<GameHistoryDetail />} />
          <Route path='/games/:gameId/history' element={<GameHistoryDetail />} />
          <Route path='/charts' element={<Charts />} />
          <Route path='/login' element={<Login />} />
          {/* 个人资料与管理员资料维护复用同一组件，但本人模式由前后端共同限制字段权限。 */}
          <Route path='/changeUser' element={<AdminEditMember selfMode />} />
          <Route path='/updatePassword' element={<UpdatePassword />} />
          <Route path='/customSeason' element={<CustomSeason />} />
          <Route path='/seasonInsert' element={<SeasonInsert />} />
          <Route path='/firstTeam' element={<FirstTeam />} />
          <Route path='/avatarAudit' element={<AvatarAudit />} />
          <Route path='/avatarMember' element={<AvatarMember />} />
          <Route path='/levelAudit' element={<LevelAudit />} />
          <Route path='/createTeam' element={<CreateTeam />} />
          <Route path='/teamList' element={<TeamList />} />
          <Route path='/teamMember' element={<TeamMember />} />
          <Route path='/activeCharts' element={<ActiveCharts />} />
          <Route path='/positionAudit' element={<PositionAudit />} />
          <Route path='/createDinner' element={<CreateDinner />} />
          <Route path='/dinnerList' element={<DinnerList />} />
          <Route path='/dinnerDetail' element={<DinnerDetail />} />
          <Route path='/dinners/:dinnerId' element={<DinnerDetail />} />
          <Route path='/updateDinner' element={<UpdateDinner />} />
          <Route path='/gameUpdate' element={<GameUpdate />} />
          <Route path='/gameYear' element={<GameYear />} />
          <Route path='/game-years/:gameYearId' element={<GameYear />} />
          <Route path="/gameYearList" element={<GameYearList />} />
          <Route path='/gameYearCreate' element={<GameYearCreate />} />
          <Route path='/gameYearUpdate' element={<GameYearUpdate />} />
          <Route path='/createGamePk' element={<CreateGamePk />} />
          <Route path='/littleGame' element={<LittleGameInfo />} />
          <Route path='/confrontation' element={<Confrontation />} />
          <Route path='/album' element={<Album />} />
          <Route path='/albumUpload' element={<AlbumUpload />} />
          <Route path='/happyEvent' element={<HappyEvent />} />
          <Route path='/happyEventCreate' element={<HappyEventCreate />} />
          <Route path="*" element={<Navigate to={isLoggedIn ? "/home" : "/login"} replace />} />
        </Routes>}
      </div>
      {showTabBar && <div className='glass-tab-bar-container'>
        <TabBar
          className='glass-tab-bar'
          activeKey={activeKey}
          // 通过 CSS 变量驱动底部菜单滑块位置，让切换动画保持丝滑。
          style={{ '--tab-active-index': activeTabIndex }}
          onChange={
            (value) => {
              handleTabNavigate(value)
            }
          }
        >
          {tabs.map(item => (
            <TabBar.Item
              key={item.key}
              icon={item.icon}
              title={item.title}
              // 当前项已经 active 时 antd-mobile 不会触发 onChange，这里补一次点击跳转。
              onClick={() => {
                if (activeKey === item.key) {
                  handleTabNavigate(item.key)
                }
              }}
            />
          ))}
        </TabBar>
      </div>}
    </div >
  );
}

export default App;
